import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { JoinJob } from './jobs-join.interface';

export const jobsAdapter: EntityAdapter<JoinJob> = createEntityAdapter<JoinJob> ( {
    selectId: job => job.id,
    sortComparer: false
  }
);
